import { render, staticRenderFns } from "./Wind.vue?vue&type=template&id=38914d80&"
import script from "./Wind.vue?vue&type=script&lang=js&"
export * from "./Wind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports